module.exports = __webpack_public_path__ + "static/img/1.85ccfad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/1.png
// module id = 4s2K
// module chunks = 0